<footer>
  <div class="page d-flex flex-column-reverse flex-md-row justify-content-between align-content-end">
    <div class="copyright">
      <p>Copyright ©{{ year }} FairBridge Hotels. All rights reserved. </p>
      <p><a routerLink="privacy-policy">Privacy Policy</a></p>
    </div>

    <div class="app-link mt-3 ">
      <h3 class="fw-bold d-none d-sm-block">Get the Mobile App</h3>
      <div class="app-icons">
        <a target="_blank" href="https://apps.apple.com/ua/app/fairbridgehotels/id1512600063">
          <img src="/assets/images/apple-download-app.svg" height="40" width="120" alt="Download on the App Store"
            style="margin-right: 15px;"></a>
        <a target="_blank" href="https://play.google.com/store/apps/details?id=app.android.fairbridgeinn"><img
            alt='Get it on Google Play' src='/assets/images/google-download-app.png' height="40" width="133" /></a>
      </div>
    </div>
  </div>
</footer>